export default __webpack_public_path__ + "static/media/IMG-0440.eb9b09bf.png";